import {
	ProfileDispatchTypes,
	ProfileTypes,
	UserProfile,
	LoadBillingAndShipping,
	KidsList,
	children,
	forgotPasswordMessage,
} from './Types';

interface DefaultProfileState {
	loading: boolean;
	user?: UserProfile;
	address?: LoadBillingAndShipping;
	Children?: KidsList;
	message?:forgotPasswordMessage;
}

const defaultState: DefaultProfileState = {
	loading: false,
};

const current = localStorage.getItem('currentChild');
const currentId = localStorage.getItem('currentChildId');

const profileReducer = (state: DefaultProfileState = defaultState, action: ProfileDispatchTypes) => {
	switch (action.type) {
		case ProfileTypes.LOADING_PROFILE:
			return { ...state, loading: true };
		case ProfileTypes.PROFILE_FAIL:
			localStorage.removeItem('token');
			localStorage.removeItem('currentChild');
			localStorage.removeItem('currentChildId');
			localStorage.removeItem('parentId');
			return { ...state, loading: false, error: action?.error?.errors };
		case ProfileTypes.UPDATE_BILLING_AND_SHIPPING_FAIL:
			return { ...state, loading: false, error: action?.error?.errors };
		case ProfileTypes.UPDATE_BILLING_AND_SHIPPING:
			return { ...state, loading: false };
		case ProfileTypes.PROFILE_PASSWORD_RESET:
			localStorage.removeItem('token');
			localStorage.removeItem('currentChild');
			localStorage.removeItem('currenChildId');
			return { ...state, loading: false };
		case ProfileTypes.PROFILE_SUCCESS:
			return { ...state, loading: true };
		case ProfileTypes.LOAD_PROFILE_SUCCESS:
			// current && current.length > 0
			// 	? localStorage.setItem('currentChild', current)
			// 	: localStorage.setItem('currentChild', action.payload.Children[0].fullName);
			// currentId
			// 	? localStorage.setItem('currentChildId', currentId)
			// 	: localStorage.setItem('currentChildId', action.payload.Children[0].id.toString());
			return { ...state, loading: true, user: action.payload };
		case ProfileTypes.LOAD_BILLING_AND_SHIPPING:
			return { ...state, loading: false, address: { ...action.payload, loading: false } };
		case ProfileTypes.LOAD_ALL_KIDS:
			return { ...state, loading: false, Children: action.payload };
		case ProfileTypes.ACTIVATE_WELCOME:
			return { ...state };
		case ProfileTypes.FORGOT_PASSWORD:
			return { ...state,message:action.payload };
		case ProfileTypes.CLEAR_ADDRESS:
			return {...state, address:undefined}
		default:
			return state;
	}
};
export default profileReducer;
